
































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import { AdminDepositRoute } from '@/modules/deposit/routes/admin-deposit.route'
import DepositPayableTypeView from '@/modules/deposit/components/shared/DepositPayableTypeView.vue'
import BankAccountTypeView from '@/modules/bank-account/components/shared/BankAccountTypeView.vue'
import { adminDepositShowTabularColumn } from '@/modules/deposit/models/columns/admin-deposit-show-tabular.column'
import DepositStatusView from '@/modules/deposit/components/shared/DepositStatusView.vue'
import { DepositResourceType } from '@/modules/deposit/models/deposit-resource.model'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'

@Component({
  components: {
    DateTooltipped,
    DepositStatusView,
    BankAccountTypeView,
    DepositPayableTypeView,
    TabularHeader
  }
})
export default class AdminDepositShowTabular extends Vue {
  constructor(
    private readonly route: AdminDepositRoute
  ) {
    super()
  }

  @Prop({ required: true }) deposit: DepositResourceType
  private columnsData = adminDepositShowTabularColumn()

  get depositData() {
    return this.deposit.data
  }

  private get columns() {
    return this.filterColumns()
  }

  filterColumns() {
    return this.columnsData
  }

}
